import { store } from './map'
import { updateStructureList } from './maplist'


export function fetchStructures() {
  const url = new URL('/structure/search', window.location.origin);
  const parameters = {
    latitude: store.startLocation.lat(),
    longitude: store.startLocation.lng(),
    region: store.input.region
  }

  if (store.filters.length > 0) {
    parameters.filters = store.filters
  }

  url.search = new URLSearchParams(parameters)

  const headers = new Headers();
  headers.append('Content-Type', 'application/json')

  fetch(url, {
    headers: headers,
  })
    .then(response => response.json())
    .then(results => {
      store.structures = results
      updateStructureList(0)
    })
    .catch(error => {
      console.error('Error:', error);
    })
}
